<template>
	<div class="physician_visits_diagnosis">
		<div class="doctor bg-white">
			<div class="avatar">
				<img :src="info.doctorAvatar" alt="" />
			</div>
			<div class="info">
				<h2>
					{{ info.doctorName }}
					<span>{{ info.title }}</span>
				</h2>
				<p>预约人：{{ info.accountPhone }}</p>
				<p>咨询时间：{{ info.actualStartTime }}</p>
			</div>
		</div>
		<base-card
			class="mt-28"
			title="主诉"
			header-border
			v-if="(info.chiefContent || []).length || (info.chiefPictureUrls || []).length"
		>
			<div class="card_content">
				<p v-if="(info.chiefContent || []).length">{{ info.chiefContent }}</p>
				<base-upload
					v-if="(info.chiefPictureUrls || []).length"
					:value="info.chiefPictureUrls"
					preview
					column="4"
				></base-upload>
			</div>
		</base-card>
		<base-card class="mt-28" title="咨询小结" header-border v-if="info.conclusion">
			<div class="card_content">
				<p>{{info.conclusion}}</p>
			</div>
		</base-card>
		<base-card class="mt-28" title="医生建议" header-border v-if="info.suggest">
			<div class="card_content">
				<p>{{info.suggest}}</p>
			</div>
		</base-card>
	</div>
</template>

<script>
	export default {
		name: 'physicianVisitsDiagnosis',
		data: () => ({
			info: {}
		}),
		created () {
			this.load()
		},
		methods: {
			async load () {
				const res = await this.$api.physicianVisits.getDoctorDiagnosis(this.$route.params.id)
				if (!res.code) {
					console.log(res.data)
					res.data.startTime = res.data.startTime.substring(0, res.data.startTime.lastIndexOf(':'))
					res.data.chiefPictureUrls = (res.data.chiefPictureUrls || []).map(item => ({ url: item }))
					this.info = res.data
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.physician_visits_diagnosis {
		padding: 32px;
		.doctor {
			display: flex;
			border-radius: 16px;
			padding: 32px 28px;
			box-sizing: border-box;
			.avatar {
				flex: 0 0 88px;
				>img {
					width: 88px;
					height: 88px;
					border-radius: 16px;
					vertical-align: middle;
				}
			}
			.info {
				padding-left: 24px;
				color: rgba(0, 0, 0, 0.8);
				h2 {
					font-family: PingFangSC-Semibold;
					font-size: 34px;
					font-weight: normal;
					margin-bottom: 24px;

					>span {
						padding-left: 12px;
						font-family: PingFangSC-Regular;
						font-size: 28px;
					}
				}
				p {
					font-family: PingFangSC-Regular;
					font-size: 28px;
					font-weight: normal;
					line-height: 28px;
					margin-top: 20px;
				}
			}
		}
		.card_content {
			>p {
				margin: 26px 0;
				line-height: 40px;
				font-family: PingFangSC-Regular;
				font-size: 28px;
				font-weight: normal;
				letter-spacing: 0.38px;
				color: #000000;
			}
		}
	}
</style>
